<template>
  <b-row align-h="center">
    <b-col sm="12">
      <b-form @submit.prevent="guardar">
        <b-row>
          <b-col cols="6"
                 offset="3"
          >
            <b-form-group breakpoint="md"
                          label="Modelo:"
            >
              <el-select id="modelo"
                         name="modelo"
                         v-model="selectedTarjetasEmergencia.id_modelo"
                         :options="modelos"
              >
                <el-option v-for="modelo in modelos"
                           :value="modelo.value"
                           :label="modelo.text"
                           :key="modelo.value"
                />
              </el-select>
            </b-form-group>
          </b-col>
          <b-form-group class="col-12" v-if="selectedTarjetasEmergencia.encabezado_pie_pagina">
            <label for="encabezado">
              Encabezado <span style="color: red">(*)</span>
            </label>
            <b-form-textarea id="encabezado"
                             name="encabezado"
                             data-vv-as=" "
                             required
                             v-model="selectedTarjetasEmergencia.encabezado"
            />
          </b-form-group>
          <b-form-group class="col-12" v-if="selectedTarjetasEmergencia.encabezado_pie_pagina">
            <label for="pie_pagina">
              Pie de página <span style="color: red">(*)</span>
            </label>
            <b-form-textarea id="pie_pagina"
                             name="pie_pagina"
                             data-vv-as=" "
                             required
                             v-model="selectedTarjetasEmergencia.pie_pagina"
            />
          </b-form-group>
        </b-row>
        <b-row>
          <b-col class="text-center">
            <hr />
            <b-button @click="backRoute()"
                      size="sm"
                      variant="secondary"
                      class="float-left"
            >
              <i class="fa fa-reply fa-lg"></i>
              Volver
            </b-button>

            <b-button v-if="validarPermisoComponente('empresa-editar-tarjetas-emergencia')" variant="primary"
                      class="align-middle btn-sm"
                      type="submit"
            >
              <i class="fa fa-save"/>
              Guardar
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </b-col>
  </b-row>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex';
import { validarPermisoComponente } from "@/plugins/acl";
import Vue from 'vue';

export default {
  name: 'empresa-tarjetas-emergencia',
  data() {
    return {
        validarPermisoComponente: validarPermisoComponente,
    };
  },
  computed: {
    ...mapState('configTarjetasEmergencia', ['selectedTarjetasEmergencia', 'modelos']),
  },
  async mounted() {
    await this.getModelos();
    await this.getTarjetasEmergencia(this.$route.params.id);
    this.updateEncabezadoPiePagina(this.selectedTarjetasEmergencia.id_modelo);
  },
  methods: {
    async guardar() {
      await this.guardaTarjetasEmergencia(this.$route.params.id);
    },
    backRoute(){
        const currentPath = this.$route.path;
        if (currentPath.includes("/my-company")) {
            this.$router.go(-1);
        }else {
            this.$router.push("/empresas");
        }
    },
    updateEncabezadoPiePagina(val) {
      if (val !== null && val !== '') {
        let modelo = this.modelos.filter(modelo => modelo.value === val);
        Vue.set(this.selectedTarjetasEmergencia, 'encabezado_pie_pagina', (modelo.length !== 0 && modelo[0].head_and_footer === 1));
      }
    },
    ...mapActions('configTarjetasEmergencia', ['guardaTarjetasEmergencia', 'getModelos', 'getTarjetasEmergencia']),
    ...mapMutations('configTarjetasEmergencia', ['resetdefaultTarjetasEmergencia'])
  },
  watch: {
    'selectedTarjetasEmergencia.id_modelo'(val) {
        this.updateEncabezadoPiePagina(val);
    },
  }
};
</script>
